import { Phone, MapPin, Clock, Baby, DollarSign } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 px-4"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="font-hand text-3xl text-[#FF6B9E]">~ get in touch ~</span>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl text-gray-900 mt-2">
            Ready to <span className="text-[#38E5B6]">book us?</span>
          </h2>
          <p className="mt-4 text-lg text-gray-700 font-semibold max-w-2xl mx-auto">
            Give us a call — one of us will pick up and help find a time that works!
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <a
            href="tel:94825353"
            data-testid="contact-phone"
            className="group bg-[#FF6B9E] border-4 border-gray-900 rounded-3xl p-8 shadow-pop btn-pop block text-center"
          >
            <div className="mx-auto w-16 h-16 bg-white border-2 border-gray-900 rounded-2xl flex items-center justify-center mb-5 group-hover:rotate-12 transition-transform">
              <Phone size={28} className="text-gray-900" strokeWidth={2.5} />
            </div>
            <p className="font-bold text-sm text-white/90 mb-2 uppercase tracking-wider">
              Call the Club
            </p>
            <p className="font-display text-4xl sm:text-5xl text-white">9482 5353</p>
          </a>
        </div>

        {/* Pricing badge */}
        <div className="max-w-lg mx-auto mt-6">
          <div
            data-testid="contact-pricing"
            className="bg-white border-4 border-gray-900 rounded-3xl p-5 shadow-pop -rotate-1 flex items-center justify-center gap-3"
          >
            <div className="w-12 h-12 bg-[#38E5B6] border-2 border-gray-900 rounded-full flex items-center justify-center">
              <DollarSign size={24} className="text-gray-900" strokeWidth={3} />
            </div>
            <div className="text-center">
              <p className="font-display text-2xl sm:text-3xl text-gray-900 leading-none">
                $18 AUD <span className="text-[#FF6B9E]">/ hour</span>
              </p>
              <p className="text-xs font-bold text-gray-600 mt-1 uppercase tracking-wider">
                Cash only
              </p>
            </div>
          </div>
        </div>

        {/* Info strip */}
        <div className="grid sm:grid-cols-3 gap-4 max-w-4xl mx-auto mt-8">
          <div
            data-testid="contact-ages"
            className="bg-[#FF8E72] border-4 border-gray-900 rounded-3xl p-5 flex items-center gap-4 rotate-1"
          >
            <Baby size={26} className="text-gray-900 flex-shrink-0" />
            <div>
              <p className="font-display text-lg text-gray-900">Ages We Sit</p>
              <p className="text-sm font-semibold text-gray-800">
                Kids age 7 and under only.
              </p>
            </div>
          </div>
          <div
            data-testid="contact-area"
            className="bg-[#FFD166] border-4 border-gray-900 rounded-3xl p-5 flex items-center gap-4 -rotate-1"
          >
            <MapPin size={26} className="text-gray-900 flex-shrink-0" />
            <div>
              <p className="font-display text-lg text-gray-900">Our Neighborhood</p>
              <p className="text-sm font-semibold text-gray-800">
                Based in the Hornsby community — we babysit close to home!
              </p>
            </div>
          </div>
          <div
            data-testid="contact-hours"
            className="bg-[#38E5B6] border-4 border-gray-900 rounded-3xl p-5 flex items-center gap-4 rotate-1"
          >
            <Clock size={26} className="text-gray-900 flex-shrink-0" />
            <div>
              <p className="font-display text-lg text-gray-900">When We're Free</p>
              <p className="text-sm font-semibold text-gray-800">
                Weekends & holidays — sometimes after school (it depends!). No later than 8:30 PM.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
